import React, { createContext, useReducer } from "react"
import AppReducer from "./AppReducer"

let initialState = {
  image: null,
  colors: [],
}

const AppContext = createContext()

const GlobalContextProvider = (props) => {
  const [globalState, dispatch] = useReducer(AppReducer, initialState)

  const setImage = (image) => {
    dispatch({
      type: "SET_IMAGE",
      payload: image,
    })
  }

  const setColors = (colors) => {
    dispatch({
      type: "SET_COLORS",
      payload: colors,
    })
  }

  return (
    <AppContext.Provider
      value={{
        globalState,
        setImage,
        setColors,
      }}
    >
      {props.children}
    </AppContext.Provider>
  )
}

export { AppContext, GlobalContextProvider }
